import axios, { AxiosResponse } from 'axios';
import { getIdToken } from '../firebaseConnection/authentication';
import { UserData } from '../types/transport';

interface UserUpdate {
  email?: string;
  disabled?: boolean;
  password?: string;
}

export const updateUser = async (
  idToken: string,
  userId: string,
  userUpdate: UserUpdate,
): Promise<AxiosResponse> => {
  const { email, disabled, password } = userUpdate;

  return axios({
    method: 'patch',
    url: `${process.env.REACT_APP_UPDATE_USER_BASE_URL}/${userId}`,
    data: {
      email,
      disabled,
      password,
    },
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
  });
};

export const getUser = async (userId: string): Promise<UserData> => {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Nicht eingeloggt?');

  const { data } = await axios({
    method: 'get',
    url: `${process.env.REACT_APP_UPDATE_USER_BASE_URL}/${userId}`,
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
  });

  return data;
};
